import React from 'react'
import { DriveItem, SharedWithUsers } from '../../../../../../interfaces/caseFileDrive/DriveFiles';
import { Button, Form, ListGroup, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { UnshareFileAsync } from '../../../../../../services/fileServices/FileService';
import { toast } from 'react-toastify';
import { showConfirmationDialog } from '../../../../../modal/ConfimationModal/Confimation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo, faUserSlash } from '@fortawesome/free-solid-svg-icons';

interface ShowUsersModalProps {
    showUsersModal: boolean;
    handleCloseUsersModal: () => void;
    driveItem: DriveItem;
    authToken : string;
    refreshCurrentFolder : () => void;
}

const ShowUsersModal = ({
    handleCloseUsersModal,
    driveItem,
    showUsersModal,
    authToken,
    refreshCurrentFolder
}: ShowUsersModalProps) => {

    // Fuction to unshare the File 
    const handleUnshareUser = async (fileSharedWithUserId : string) =>{
        const isConfirm = await showConfirmationDialog();
        if(!isConfirm){
            return;
        }
        UnshareFileAsync(authToken, fileSharedWithUserId).then((res)=>{
            if(res.success){
                toast.success(res.message);
                // refresh the Drive
                refreshCurrentFolder(); 
                // close the modal
                handleCloseUsersModal();
            }else{
                toast.error(res.message);
            }
        }).catch((err) =>{
            toast.error(err.message);
        })
    }


    return (
        <>
            <Modal show={showUsersModal} onHide={handleCloseUsersModal} className='custom_popup' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Shared With Users</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ListGroup>
                        {driveItem.sharedWithUsers?.map((user, index) => (
                            <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                                <Link
                                    to={`/profile/user/${user.id}`}
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    {user.firstName} {user.lastName}
                                </Link>
                                {/* <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => handleUnshareUser(user.sharedWithUsersId)}
                                >
                                    Unshare
                                </Button> */}
                                <FontAwesomeIcon title='Unshare' className='cursor-pointer' icon={faUndo} color='red' onClick={() => handleUnshareUser(user.sharedWithUsersId)} />
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseUsersModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ShowUsersModal